export default "__VITE_ASSET__BjX9cytL__"